  <div  style="position:fixed; top:0; left:0; width:100%; height:100%; display:flex;">

 
 <!--	qr Enter

<qrcode [qrdata]="'https://www.npmjs.com/package/angularx-qrcode'" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
-->

 <div  *ngIf="blocked && !loading && !success"  class="wrapper">
		 <div class="form">
        <p class="header">Сторінка не дійсна. Відскануйте QR код знову.</p>

	  </div>
  </div>

	<div *ngIf="!loading && !blocked" class="wrapper">

    <div class="form" *ngIf="!success">
        
     <div class="d-flex">  
		<div class="d-flex"  style="flex:1;">
		    <input nbInput fullWidth (change)="password = $event.target.value" [value]="password" placeholder="Введіть код" type="text" />
		</div>

		<div class="d-flex" style="margin-left:10px;">
		    <button nbButton  status="primary"  fullWidth (click)="submit()">
		          Дивитися
		    </button>
		</div>

	</div>

 
 
     </div>
 

	 <div  *ngIf="success" class="form">
        <p class="header">Вхід виконано</p>

	  </div>
    

		


	</div>
 

</div>








 


	 <div *ngIf="loading" style="position: fixed; z-index: 1777;  width:100%; height:100%; top:0; left: 0; display: flex; align-self: center;">
        <div style="margin: auto;"> 
             <app-loader></app-loader>
         </div>
        </div>
  
